module.exports = __webpack_public_path__ + "static/img/3.4df671e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/12/zh/3.png
// module id = VCwW
// module chunks = 0